import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';
import { ProfileService } from '../../services/profile.service';
import { DashboardClientStats } from '../../components/dashboard-client-stats/dashboard-client-stats';
import { LastContent } from '../../components/last-content/last-content';
import { Faq } from '../../components/faq/faq';
import { WeeklyTrends } from '../../components/weekly-trends/weekly-trends';

@Component({
  selector: 'app-dashboard',
  imports: [TranslateModule, UpperFirstLetterPipe, DashboardClientStats, LastContent, Faq, WeeklyTrends],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.scss',
})
export class Dashboard {
  profileService: ProfileService = inject(ProfileService);
}
